import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { useSaveChecklistType } from './_requests/saveChecklistType'
import { useTranslation } from 'react-i18next'

const translatedChecklistTypes = (data, t) => {
  if (!data) return []
  const result = data.map(checklistType => {
    return { ...checklistType, name: t(checklistType.name) }
  })
  return result
}

const QUERY = gql`
  query ChecklistTypes($page: Int, $search: String, $filter: ChecklistTypeFilter) {
    checklistTypes(page: $page, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const useChecklistTypesLoader = () => {
  const { t } = useTranslation('common')
  const query = usePromiseQuery(QUERY, { client: checklistsClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(pathOr([], ['data', 'checklistTypes'])).then(data => translatedChecklistTypes(data, t))
  }
}

const ChecklistTypesSelectV2 = ({
  onChange,
  value,
  canCreate,
  interpolations = [],
  assign,
  multiple = false,
  ...props
}) => {
  const createChecklistType = useSessionPermission('createChecklistType')
  const getOptions = useChecklistTypesLoader()
  const [onCreate, { loading }] = useSaveChecklistType()

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={canCreate && createChecklistType && onCreate}
      multiple={multiple}
      assign={assign}
      {...props}
    />
  )
}

export default ChecklistTypesSelectV2
